<template>
    <div class="airdrop_passcard">
        <!-- 背景层 -->
        <div class="airdrop_passcard-bg"></div>
        <!-- top -->
        <div class="top" :style="{paddingTop: 18 + statusBarHeight + 'px'}">
            <Back :clickHandle="handleClosePage"/>
            <div class="top-title">Passcard Airdrop</div>
        </div>
        <!-- 顶部板块 -->
        <div class="topView">
            <img class="title" :src="require(`@/assets/images/YuliApp/AirdropPasscard/title/en.png`)">
            <div class="line"></div>
            <div class="content">
                <span>{{ TimeDate.start }}</span><span :style="{margin: '0 8px'}">-</span><span>{{ TimeDate.end }}</span>
            </div>
        </div>
        <!-- 中间板块 -->
        <div class="middleView">
            <div class="labelView">
                <span>Remaining Tickets</span>
                <span>{{remainingCurrent}}/{{ remainingTotal }}</span>
            </div>
            <Process :cur_kep="remainingCurrent" :total_kep="remainingTotal"/>
            <div class="left" v-html="applyTextCoding('<%> left')"></div>
        </div>
        <!-- 剩余内容 -->
        <div class="bottomView">
            <div class="tips style1">
                {{ `Each ticket obtained can be used to redeem ONE Passcard NFT
                    Passcard will be airdropped after the end of the campaign` }}
            </div>
            <div class="tipsModel">
                <div class="labelView">
                    <div>My Rewards</div>
                    <div class="wenhao" @click="showRulesHandle(true)">
                        <img :src="require('@/assets/images/YuliApp/AirdropPasscard/icon_wenhao.png')">
                        <span>How does it work</span>
                    </div>
                </div>
                <div class="contentView">
                    <div class="box">
                        <img :src="require('@/assets/images/YuliApp/AirdropPasscard/icon_passcard_ticket.png')">
                        <div class="label">Passcard Ticket</div>
                        <div class="holdView">
                            <span :style="{marginRight: '8px'}">Holding:</span>
                            <span :style="{color: PasscardTicketNumber == 0 ? '#F42E5E' : ''}">{{ PasscardTicketNumber }}</span>
                        </div>
                    </div>
                    <div class="arrow"></div>
                    <div class="box">
                        <img :src="require('@/assets/images/YuliApp/AirdropPasscard/passcard.png')">
                        <div class="label">Passcard NFT</div>
                        <div class="holdView">
                            <span :style="{marginRight: '8px'}">Airdrop Rewards:</span>
                            <span :style="{color: PasscardNFTNumber == 0 ? '#F42E5E' : ''}">{{ PasscardNFTNumber }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tips style2">
                Tips: The more you purify Terra, The higher the Odds of you winning a Passcard!
            </div>
        </div>

        <ActivityIntro v-if="isShowRule" @close="showRulesHandle"/>
    </div>
</template>
  
<script>
import { onBeforeMount, onMounted, ref, nextTick, getCurrentInstance } from "vue";
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import { getPasscardlist } from "@/api/activityOther.js";
import { TOAST_TYPE } from "@/components/Toast/index.vue";
import Back from "./Back";
import Process from "./Process";
import ActivityIntro from "./ActivityIntro";
// import audioManager from "@/utils/audioManager";
import _ from "lodash";
import {getGainEntryExplainLanguage} from "@/api/language.js";
import store from "@/store";

export default {
components: {
    Back,
    Process,
    ActivityIntro
},
props: {
    id: {
        type: Number,
        default: 0,
    },
},
watch: {
    init: {
      async handler(value) {
        if (!value) {
          return;
        }
        await this.pageInit();
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        console.log('languageEnv: ', value);
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        console.log('languagePackage: ', value);
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    }
},
data() {
    return {};
},
computed: {
    ...mapState({
        init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
        languageEnv: (state) => state.global.languageEnv,
        languagePackage: (state) => state.global.languagePackage,
    }),
},
setup(props) {
    const { proxy } = getCurrentInstance();
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const PasscardTicketNumber = ref(0);
    const PasscardNFTNumber = ref(0);
    const remainingTotal = ref(180);
    const remainingCurrent = ref(0);
    const isShowRule = ref(false);
    const TimeDate = ref({
        start: '1/15',
        end: '1/19'
    })
    onBeforeMount(async ()=>{
      appBridging.getSettingLaungage();
      const res = await getGainEntryExplainLanguage();
      store.dispatch("global/setLanguagePackage", res);// 存到stroe
    })

    onMounted(()=>{
        appBridging.getStatusBarHeight();
    });

    const pageInit = async () => {
        try {
            const res = await getPasscardlist();
            if(res?.data){
                const { got, total, total_got, begin_time, end_time } = res.data;
                remainingTotal.value = total;
                remainingCurrent.value = total_got;
                PasscardNFTNumber.value = got;
                PasscardTicketNumber.value = got;
                const startDate = new Date(begin_time * 1000);
                const endDate = new Date(end_time * 1000);
                TimeDate.value = {
                    start: `${startDate.getMonth()+1}/${startDate.getDate()}`,
                    end: `${endDate.getMonth()+1}/${endDate.getDate()}`
                }
            }
            appBridging.closeLoading(); 
        } catch (error) {
            console.log(error.response.data);
            proxy.$toast.show({
                msg: localesPackage.value?.['katharsis_toast_msg1']?.[localesEnv.value],
                type: TOAST_TYPE.ERROR,
            })
        }
    }

    const handleClosePage = () => {
        appBridging.closePage();
    }

    /** 高光剩余文本*/
    const applyTextCoding = (text) => {
        const Number = `${(((remainingTotal.value-remainingCurrent.value) / remainingTotal.value) * 100).toFixed(1)}%`;
        const JSX = `<span style="color: #FFF72C;font-weight: 600;">${Number}</span>`;
        const rpcText = text?.replace("<%>", JSX);
        return rpcText;
    }

    const showRulesHandle = (state) => {
        isShowRule.value = state;
    }

    return {
        applyTextCoding,
        handleClosePage,
        showRulesHandle,
        pageInit,
        PasscardTicketNumber,
        PasscardNFTNumber,
        remainingTotal,
        remainingCurrent,
        isShowRule,
        TimeDate,
        localesPackage,
        localesEnv,
    };
},
};
</script>
  
<style lang="less" scoped>
    @topHeight: 48px;
    @switchHeight: 60px;
    @screenTop: 18px;
    .airdrop_passcard{
        position: fixed;
        top: 0;
        z-index: 0;
        width: 100%;
        height: 100%;
        background: #0F193B;
        &-bg{
            position: absolute;
            z-index: -1;
            width: 100%;
            height: 398px;
            top: 0;
            left: 0;
            background: url("~@/assets/images/YuliApp/AirdropPasscard/passcard_bg.png") no-repeat
            top left;
            background-size: 100% 100%;
        }
        .topView{
            margin-top: 100px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .title{
                height: 60px;
                margin-bottom: 7px;
            }
            .line{
                width: 265px;
                height: 16px;
                background: url("~@/assets/images/YuliApp/AirdropPasscard/line.png") no-repeat
                top left;
                background-size: 100% 100%;
                margin-bottom: 6px;
            }
            .content{
                color: #41ffe8;
                text-align: center;
                font-family: "PingFang SC";
                font-size: 20px;
                font-weight: 600;
                line-height: 20px;
                @textShadowColor: #15245E;
                text-shadow: 0 2px @textShadowColor, 2px 0 @textShadowColor, -2px 0 @textShadowColor, 0 -2px @textShadowColor;
            }
        }
        .middleView{
            margin: 10px auto;
            margin-top: 164px;
            width: 289px;
            height: 60px;
            border-radius: 4px;
            border: 1px solid #00e0ff30;
            background: linear-gradient(180deg, #0E1D4F 0%, #06A1AE 100%); 
            padding: 5px 12px;
            .labelView{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                color: #ffffff;
                font-size: 12px;
                font-weight: 400;
                margin-bottom: 5px;
            }
            .left{
                font-size: 12px;
                font-weight: 400;
                color: #ffffff;
                .blur{
                    font-weight: 600;
                    color: #FFF72C;
                    margin-right: 4px;
                }
            }
        }
        .bottomView{
            .tips{
                opacity: 0.8;
                color: #ffffff;
                font-size: 12px;
                font-weight: 400;
                white-space: pre-line;
            }
            .style1{
                letter-spacing: -0.12px;;
            }
            .tipsModel{
                width: 355px;
                height: 229px;
                background: url("~@/assets/images/YuliApp/AirdropPasscard/tips_bg.png") no-repeat
                top left;
                background-size: 100% 100%;
                margin: 14px auto;
                padding: 11px 14px;
                box-sizing: border-box;
                .labelView{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    color: #ffffff;
                    font-family: "PingFang SC";
                    font-size: 14px;
                    font-weight: 500;
                    margin-bottom: 22px;
                    .wenhao{
                        font-size: 12px;
                        font-weight: 400;
                        color: #24E8E8;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        img{
                            width: 14px;
                            height: 14px;
                            margin-right: 4px;
                        }
                    }
                }
                .contentView{
                    margin: 0 auto;
                    width: 281.11px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    position: relative;
                    .box{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-family: "PingFang SC";
                        color: #ffffff;
                        img{
                            width: 112px;
                            height: 112px;
                            margin-bottom: 3px;
                        }
                        .label{
                            margin-bottom: 4px;
                            font-size: 15px;
                            font-weight: 500;
                        }
                        .holdView{
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: center;
                            font-size: 13px;
                            font-weight: 400;
                        }
                    }
                    .arrow{
                        position: absolute;
                        top: 25%;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 26px;
                        height: 26px;
                        background: url("~@/assets/images/YuliApp/AirdropPasscard/arrow.png") no-repeat
                        top left;
                        background-size: 100% 100%;
                    }
                }
            }
            .style2{
                width: 344px;
            }
        }
    }
    .top{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: @topHeight;
        &-title{
            color: #ffffff;
            font-size: 16px;
            font-weight: 600;
            font-family: "PingFang SC";
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
        }
    }

@media screen and (max-height: 760px) {
    .airdrop_passcard{
        .bottomView{
            overflow: scroll;
            min-height: 200px;
            height: calc(100vh - 460px);
        }
    }
}
</style>